import { cn } from '../../utils/cn';
import { TrendingUp, TrendingDown, LucideIcon } from 'lucide-react';

interface StatCardProps {
  title: string;
  value: string | number;
  change?: number;
  changeLabel?: string;
  icon: LucideIcon;
  iconColor?: string;
  className?: string;
}

export function StatCard({
  title,
  value,
  change,
  changeLabel = '较昨日',
  icon: Icon,
  iconColor = 'text-accent-600',
  className,
}: StatCardProps) {
  const isPositive = change && change > 0;
  const isNegative = change && change < 0;

  return (
    <div
      className={cn(
        'bg-white rounded-xl border border-zinc-200 p-6 shadow-sm hover:shadow-md transition-shadow',
        className
      )}
    >
      <div className="flex items-start justify-between">
        <div>
          <p className="text-sm font-medium text-zinc-500">{title}</p>
          <p className="mt-2 text-3xl font-bold text-zinc-900">{value}</p>
          {change !== undefined && (
            <div className="mt-2 flex items-center gap-1">
              {isPositive ? (
                <TrendingUp className="w-4 h-4 text-success-600" />
              ) : isNegative ? (
                <TrendingDown className="w-4 h-4 text-error-600" />
              ) : null}
              <span
                className={cn(
                  'text-sm font-medium',
                  isPositive && 'text-success-600',
                  isNegative && 'text-error-600',
                  !isPositive && !isNegative && 'text-zinc-500'
                )}
              >
                {isPositive ? '+' : ''}{change}%
              </span>
              <span className="text-sm text-zinc-400">{changeLabel}</span>
            </div>
          )}
        </div>
        <div
          className={cn(
            'p-3 rounded-xl bg-zinc-50',
            iconColor.replace('text-', 'bg-').replace('600', '100')
          )}
        >
          <Icon className={cn('w-6 h-6', iconColor)} />
        </div>
      </div>
    </div>
  );
}
